import { render } from "./show-goods.vue?vue&type=template&id=42ffc7a2&scoped=true&ts=true"
import script from "./show-goods.vue?vue&type=script&lang=ts"
export * from "./show-goods.vue?vue&type=script&lang=ts"

import "./show-goods.vue?vue&type=style&index=0&id=42ffc7a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ffc7a2"]])

export default __exports__